import { differenceInCalendarDays, parseISO } from 'date-fns';

// Só faturamento e volume acumulam ao longo do período; conversão e tempo de venda
// são taxas/médias e não têm "ritmo diário".
const CUMULATIVE_TYPES = ['revenue', 'sales_count', 'product_sales'];

const ON_TRACK_RATIO = 0.85;

// Ritmo de uma meta vigente: compara o atingido com o esperado até hoje (linear no período).
// status: no_data | achieved | in_progress (taxas) | ahead | on_track | at_risk.
export const goalPace = (goal, today = new Date()) => {
  const { state, currentValue, targetValue } = goal.progress;
  if (state === 'no_data') return { status: 'no_data' };
  if (state === 'achieved') return { status: 'achieved' };
  if (!CUMULATIVE_TYPES.includes(goal.goalType)) {
    return { status: 'in_progress' };
  }

  const start = parseISO(goal.startDate);
  const end = parseISO(goal.endDate);
  const totalDays = differenceInCalendarDays(end, start) + 1;
  const elapsedDays = Math.min(
    Math.max(differenceInCalendarDays(today, start) + 1, 0),
    totalDays
  );
  const daysLeft = Math.max(differenceInCalendarDays(end, today) + 1, 0);

  const expected = (targetValue * elapsedDays) / totalDays;
  const ratio = expected > 0 ? currentValue / expected : 1;
  let status = 'at_risk';
  if (ratio >= 1) status = 'ahead';
  else if (ratio >= ON_TRACK_RATIO) status = 'on_track';

  return {
    status,
    daysLeft,
    dailyNeeded: daysLeft > 0 ? (targetValue - currentValue) / daysLeft : null,
  };
};
